import { useMemo } from 'react';
import Box from '@mui/material/Box';

// project imports
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';

import { useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer: React.FC = () => {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(() => <DrawerHeader open={drawerOpen} />, [drawerOpen]);

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 } }} aria-label="mailbox folders">
      <MiniDrawerStyled variant="permanent" open={drawerOpen} sx={{ '& .MuiDrawer-paper': { backgroundColor: '#fff' } }}>
        {drawerContent}
      </MiniDrawerStyled>
    </Box>
  );
};

export default MainDrawer;
